




















import { DynamicDocumentItem, DynamicDocumentItemData, InstallationModuleData, MechanicInstallation } from "@/types";

import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    installation: { type: Object as PropType<MechanicInstallation> },
    data: Object as PropType<DynamicDocumentItemData>
  },

  methods: {
    padTo5Numbers(n: number): string | null {
      if (!n) {
        return null;
      }

      return ("00000" + n).slice(-5);
    },

    maxLength(event: KeyboardEvent) {
      if (
        ["e", ".", ","].includes(event.key) ||
        ((event.target as HTMLInputElement).value.toString().length === 5 &&
          !document.getSelection()?.toString() &&
          /^\d$/i.test(event.key))
      ) {
        event.preventDefault();
      }
    }
  },

  computed: {
    value: {
      get(): string | null | undefined {
        return this.moduleData.numberOfBus;
      },

      set(val: number) {
        this.$set(this.moduleData, "numberOfBus", this.padTo5Numbers(val));
      }
    }
  }
});
